import * as Notify from './notify';

const settings = {
  btnLocate: document.querySelector<HTMLButtonElement>(`#btnLocate`)!,
  btnVisit: document.querySelector<HTMLButtonElement>(`#btnVisit`)!

};

export const events = new EventTarget();

export const showLocationButton = () => {
  const { btnLocate } = settings;
  btnLocate.classList.remove(`hidden`); // show visit
}

export const showVisitButton = () => {
  const { btnVisit } = settings;
  btnVisit.classList.remove(`hidden`); // show visit
}


function locateProbe() {
  const { btnLocate, btnVisit } = settings;
  try {
    //throw new Error(`locateProbe`);
    navigator.permissions.query({ name: `geolocation` }).then((result) => {
      if (result.state === `granted`) {
        btnVisit.classList.remove(`hidden`); // show visit

        locate();
      } else if (result.state === `prompt`) {
        showVisitButton();
        showLocationButton();

        events.dispatchEvent(new CustomEvent(`not-located`, {
          detail: {}
        }));
      }
    });
  } catch (error) {
    events.dispatchEvent(new CustomEvent(`not-located`, {
      detail: {}
    }));
    showVisitButton();
    showLocationButton();
  }

}

function locate() {
  const { btnLocate } = settings;

  navigator.geolocation.getCurrentPosition((pos) => {
    Notify.show(`Located!`, true);
    btnLocate.classList.add(`hidden`); // hide Locate
    events.dispatchEvent(new CustomEvent(`located`, {
      detail: pos.coords
    }));
  }, (error) => {
    Notify.show(error.message);
  }, {
    enableHighAccuracy: false,
    maximumAge: 1000 * 60
  })
}

export function init() {
  const { btnLocate } = settings;
  btnLocate.addEventListener(`click`, locate);

  setTimeout(() => locateProbe(), 500);
}